<template>
    <div class="c-panel c-panel--border c-panel--expand margin-b-24">
        <h3 class="margin-b-8" v-if="title">{{title}}</h3>
        <div class="fs-small"><slot></slot></div>
    </div>
</template>

<script>
export default {
    props: {
        title: String,
    }
}
</script>